import { useContext } from 'react';

import { WillRedirectOnLoadContext } from '../will-redirect-on-load-contexts';

export const useWillRedirectOnLoad = () => useContext(WillRedirectOnLoadContext);
